<template lang='pug'>
.filter-by-category
  h2 {{ 'fpStore.packages.categories' | translate }}
  ul.list-group
    li.list-group-item.pointer(
      @click='onClick(key)',
      :class='{ active: category.selected }',
      v-for='category, key in categories'
    ) {{ category.name | translate }}
</template>

<script>

export default {
  props: {
    value: Object,
    categories: Object
  },
  methods: {
    onClick (key) { this.$emit('input', key) }
  }
}
</script>

<style lang='less'>
@import "~@/shared/styles/_variables.less";

@maxHeightModal: 380px;
@maxHeight: 800px;

@maxHeightDetailsContent:300px;
@maxHeightDetailsModalContent:300px;
@maxHeightDetailsImage:350px;
@maxHeightDetailsModalImage:350px;

.filter-by-category {
  padding-left:0;
  padding-right: 10px;
  h2 {
    margin-top: 0;
  }
  .list-group {
    max-height:@maxHeight;
    position: relative;
    padding-left: 0;
    overflow: auto;
    height: 100%;
    .list-group-item:first-child {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
    .list-group-item {
      border-top: 1px solid #dedede;
      border-left: 0;
      border-right: 0;
      border-bottom: 0;
      color: #333;
      transition: 0.25s ease-in-out;
      -moz-transition: 0.25s ease-in-out;
      -webkit-transition: 0.25s ease-in-out;
      overflow: hidden;
      font-size: 110%;
      border: none;
      position: relative;
      display: block;
      padding: 10px 15px;
      margin-bottom: -1px;
      background-color: #fff;
      &.active {
        background-color: #E6F8FD !important;
        border-color: transparent !important;
        color: inherit !important;
      }
    }
  }
}
</style>
